<template>
	<div class="card-wrap">
		<h1 class="card--title text-center mb-1">
			{{ $t('easy-to-start.card2.title') }}
		</h1>
		<h1
			class="card--text text-center mb-3"
			v-html="$t('easy-to-start.card2.sub-title')"
		></h1>
		<v-row no-gutters style="width: calc(100% + 100px); margin-left: -50px">
			<v-col
				cols="3"
				style="padding: 7px 3.5px 0 3.5px"
				v-for="i in programs"
				:key="i"
			>
				<v-img
					style="border-radius: 10px"
					:src="`https://image.tella.co.kr/v1/program/thumbnail/portrait/${language}/${i}.jpg`"
				></v-img>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	data() {
		return {
			programs: [177, 20, 22, 140, 161, 163, 168, 166],
			// 167, 169
		}
	},
	computed: {
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss" scoped>
.card-wrap {
	padding: 40px 36px 0;
	border-radius: 20px;
	box-shadow: 0 11px 33px 0 rgba(33, 51, 82, 0.1);
	background-color: #fff;
	overflow: hidden;
}
.card--title {
	font-family: NotoSansKR;
	font-size: 22px;
	font-weight: bold;
	color: #1a1a1a;
}
.card--text {
	font-size: 16px;
	letter-spacing: -0.8px;
	color: #1a1a1a;
	font-weight: normal;
}
</style>
